// Approximate center coordinates and zoom levels for each state
// Used by the interactive state map on state pages
export const STATE_MAP_CONFIG: Record<string, { center: [number, number]; zoom: number }> = {
  mi: { center: [-85.0, 44.3], zoom: 6.2 },
  wv: { center: [-80.5, 38.6], zoom: 7.5 },
  co: { center: [-105.5, 39.0], zoom: 6.5 },
  id: { center: [-114.5, 44.5], zoom: 5.8 },
  or: { center: [-121.0, 43.8], zoom: 6.0 },
  wa: { center: [-120.5, 47.5], zoom: 6.5 },
  pa: { center: [-77.5, 41.0], zoom: 6.8 },
  mt: { center: [-110.0, 47.0], zoom: 5.8 },
  tn: { center: [-86.0, 35.8], zoom: 6.8 },
  ca: { center: [-119.5, 37.5], zoom: 5.5 },
  va: { center: [-79.5, 37.8], zoom: 6.8 },
  ky: { center: [-85.5, 37.8], zoom: 6.8 },
  nc: { center: [-80.0, 35.5], zoom: 6.5 },
  az: { center: [-111.5, 34.5], zoom: 6.0 },
  wy: { center: [-107.5, 43.0], zoom: 6.2 },
  ut: { center: [-111.5, 39.3], zoom: 6.2 },
  nm: { center: [-106.0, 34.5], zoom: 6.2 },
  me: { center: [-69.0, 45.3], zoom: 6.5 },
  ny: { center: [-75.5, 43.0], zoom: 6.2 },
  ga: { center: [-83.5, 33.0], zoom: 6.5 },
  mn: { center: [-94.5, 46.3], zoom: 6.0 },
  wi: { center: [-89.5, 44.8], zoom: 6.2 },
  ia: { center: [-93.5, 42.0], zoom: 6.5 },
  mo: { center: [-92.5, 38.5], zoom: 6.2 },
  ar: { center: [-92.5, 34.8], zoom: 6.5 },
  la: { center: [-92.0, 31.0], zoom: 6.5 },
  ms: { center: [-89.7, 32.7], zoom: 6.5 },
  al: { center: [-86.8, 32.8], zoom: 6.5 },
  fl: { center: [-82.5, 28.8], zoom: 5.8 },
  sc: { center: [-81.0, 34.0], zoom: 6.8 },
  ne: { center: [-100.0, 41.5], zoom: 6.0 },
  sd: { center: [-100.0, 44.5], zoom: 6.0 },
  nd: { center: [-100.5, 47.5], zoom: 6.0 },
  ks: { center: [-98.5, 38.5], zoom: 6.2 },
  ok: { center: [-97.5, 35.5], zoom: 6.2 },
  tx: { center: [-99.5, 31.5], zoom: 5.5 },
  nv: { center: [-117.0, 39.5], zoom: 6.0 },
  oh: { center: [-82.5, 40.0], zoom: 6.8 },
  in: { center: [-86.3, 40.0], zoom: 6.8 },
  il: { center: [-89.5, 40.0], zoom: 6.2 },
  nh: { center: [-71.5, 44.0], zoom: 7.2 },
  vt: { center: [-72.7, 44.0], zoom: 7.2 },
  ct: { center: [-72.7, 41.6], zoom: 8.0 },
  ri: { center: [-71.5, 41.6], zoom: 9.0 },
  nj: { center: [-74.7, 40.2], zoom: 7.5 },
  de: { center: [-75.5, 39.2], zoom: 8.5 },
  md: { center: [-77.0, 39.3], zoom: 7.5 },
  ma: { center: [-72.0, 42.4], zoom: 7.5 },
  // Alaska is enormous — center on the south-central / Bristol Bay
  // region where most of our 15 priority sportfishing rivers cluster
  // (Kenai Peninsula, Bristol Bay, southcentral). Lower zoom shows
  // the whole state.
  ak: { center: [-152.0, 60.5], zoom: 4.2 },
  // Hawaii — center on the main 4-island cluster (Kauai → Big Island)
  // so all 5 priority rivers are in frame at the default zoom. Most
  // are on Kauai, with one on Oahu and one on the Big Island.
  hi: { center: [-157.5, 20.7], zoom: 6.5 },
  // Canada (beta) — initial 8-river launch is concentrated along the
  // AB/BC mountain corridor. Center on Banff so all rivers from
  // Sunwapta (Jasper) down to Kicking Horse (Golden) and Bow (Calgary)
  // are visible at the default zoom.
  canada: { center: [-115.5, 52.5], zoom: 5.0 },
}
